import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["orientation"];
import React from 'react';
import { Divider as ChakraDivider } from '@chakra-ui/react';
export var Divider = function Divider(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ChakraDivider, _extends({
    opacity: "1",
    borderColor: "grey.300",
    width: "auto",
    margin: "0",
    orientation: orientation
  }, rest));
};